import WebBluetoothEvents from './web_bluetooth_events';
//Types
import type { WebBLEData, WebBLEError, WebBLEEventData } from './web_bluetooth_types';

export default class WebBluetoothClient extends EventTarget {
	protected device: BluetoothDevice;
	protected server: BluetoothRemoteGATTServer;

	constructor(connectedDevice: BluetoothDevice) {
		super();
		this.device = connectedDevice;
		this.device.addEventListener('gattserverdisconnected', this._onDisconnected);
		this.initService();
	}

	/**
	 * Check if the device is currently connected.
	 */
	public get isConnected(): boolean {
		return this.device?.gatt?.connected;
	}

	/**
	 * Check if the device supports BLE notification events.
	 */
	public get supportNotifications(): boolean {
		return false;
	}

	/**
	 * Returns the currently connected Bluetooth device.
	 */
	public get connectedDevice(): BluetoothDevice {
		return this.device;
	}

	/**
	 * Connect to the BLE device.
	 */
	public connect = async () => {
		try {
			if (this.device?.gatt) this.device.gatt.disconnect();
			this.server = await this.device.gatt.connect();
		} catch (error) {
			this._onError({
				type: WebBluetoothEvents.Errors.CONNECTION_ERROR,
				message: error?.message || error,
			});
			return;
		}
		await this.initService();
	};

	/**
	 * Disconnect from the BLE device.
	 */
	public disconnect() {
		if (this.device) {
			this.device.removeEventListener('gattserverdisconnected', this._onDisconnected);
			if (this.device.gatt) {
				this.device.gatt.disconnect();
			}
		}
	}
	public async call(_method: string, _params: any = null, _auth: string = null) {}
	public async forgetDevice(): Promise<boolean> {
		try {
			if (!this?.device?.forget) return false;
			await this.device.forget();
			return true;
		} catch (error) {
			return false;
		}
	}

	public get isBLUDevice(): boolean {
		return false;
	}
	protected async initService() {}

	private _onDisconnected = async (e: Event) => {
		this._dispatchEvent(WebBluetoothEvents.DISCONNECTED);
	};
	protected _sleep(ms: number) {
		return new Promise((resolve) => setTimeout(resolve, ms));
	}
	protected _onError(error: WebBLEError) {
		this._dispatchEvent(WebBluetoothEvents.ERROR, null, error);
	}
	protected _dispatchEvent(event: string, data: WebBLEData = {}, error: WebBLEError = null) {
		const detail: WebBLEEventData = {
			id: this.device?.id,
			name: this.device?.name,
			bluDevice: this.isBLUDevice,
			data,
			error,
		};
		this.dispatchEvent(new CustomEvent(event, { detail }));
	}
}
